<template>
  <access-denied v-if="accessDenied" title="config-parametrizacoes" />
  <div class="parametrizacoes-wrapper" v-else>
    <div class="main-wrapper" v-show="!rotaAninhada">
      <div class="select-modal page-container">
        <div class="page">
          <div class="listing-header">
            <div class="title-breadcrumb">
              <h1 class="title">{{ $t("parametrizacoes") }}</h1>
              <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                  <li>
                    <a class="a-inativo">{{ $t("configs") }}</a>
                  </li>
                  <li>
                    <a aria-current="page">{{ $t("parametrizacoes") }}</a>
                  </li>
                </ul>
              </nav>
            </div>

            <div class="header-buttons">
              <button
                v-if="permissao.create && abaSelecionada == 1"
                class="save-btn"
                type="button"
                tag="button"
                @click="
                  $router.push({
                    name: 'config-parametrizacoes-new',
                    query: { abaSelecionada: $route.query.abaSelecionada },
                  })
                "
              >
                {{ $t("adicionar") }}
              </button>
            </div>
          </div>
          <ul class="nav nav-tabs nav-tabs-children">
            <li
              v-for="(aba, i) in abas"
              :key="i"
              :class="{ active: abaSelecionada == i }"
              @click="changeTab(i)"
            >
              <a data-toggle="tab">{{ $t(aba) }}</a>
            </li>
          </ul>
          <div class="abas-container">
            <Geral
              ref="tabGeral"
              v-show="abas[abaSelecionada] == 'geral'"
              @isChanged="isChanged = $event"
              :permissao="permissao"
              class="aba-content"
            />
            <Especificas
              ref="tabEspecificas"
              v-if="abasAbertas['especificas']"
              v-show="abas[abaSelecionada] == 'especificas'"
              :permissao="permissao"
              :rotaAninhada="rotaAninhada"
              class="aba-content"
            />
          </div>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapState } from "vuex";

import Geral from "@/components/conta/parametrizacoes/abas/Geral.vue";
import Especificas from "@/components/conta/parametrizacoes/abas/Especificas.vue";

export default {
  beforeRouteUpdate(to, from, next) {
    if (
      to.name.includes("config-parametrizacoes") &&
      to.name != "config-parametrizacoes"
    ) {
      this.rotaAninhada = true;
    } else {
      this.rotaAninhada = false;
    }
    next();
  },
  components: {
    Geral,
    Especificas,
  },
  data() {
    return {
      rotaAninhada: false,
      accessDenied: false,
      abaSelecionada: 0,
      abasAbertas: {},
      abas: ["geral", "especificas"],
      permissao: {},
      reloadTab: true,
      isChanged: false,
    };
  },
  mounted() {
    if (this.$route.query.abaSelecionada) {
      this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
    }
  },
  computed: {
    ...mapState(["hide"]),
  },
  created() {
    this.rotaAninhada = this.$route.name !== "config-parametrizacoes";

    this.permissao = this.hasPermissionAccess(
      "admin",
      "parametrizacoes",
      "config-parametrizacoes"
    );

    if (!this.permissao.read) {
      this.$router.push({
        name: "acesso-nao-permitido",
        params: { tela: "parametrizacoes" },
      });
    }
  },
  methods: {
    changeTab(i) {
      this.abaSelecionada = i;
      this.abasAbertas[this.abas[this.abaSelecionada]] = true;
      if (this.$route.query) {
        if (
          this.$route.query.abaSelecionada &&
          this.$route.query.abaSelecionada == this.abas[i]
        ) {
          return;
        }

        const query = { ...this.$route.query, abaSelecionada: this.abas[i] };
        this.$router.replace({ query });
      } else {
        this.$router.push({ abaSelecionada: this.abas[i] }).catch((error) => {
          if (
            error.name !== "NavigationDuplicated" &&
            !error.message.includes(
              "Avoided redundant navigation to current location"
            )
          ) {
            console.log(error);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.parametrizacoes-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.main-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.page-container {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.page {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  .nav.nav-tabs {
    margin-bottom: 5px;
    margin-top: 5px;
    flex-shrink: 0;
  }
}

.abas-container {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.aba-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.listing-header {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.title-breadcrumb {
  display: flex;
  flex-direction: column;
}

.header-buttons {
  display: flex;
  align-items: flex-start;
}
</style>
